import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from 'vue';
import {
    getQuotedPriceDetail,
    getWechatSDKSign,
    quotedPrice,
    getLocation,
    quotedPriceSupply,
    getEngineeringOffer,
getHasCard,
} from '@/api/miscellaneous';
import { useRoute, useRouter } from 'vue-router';
import CityPicker from '@/components/CityPicker.vue';
import userStoreModule from '@/store/modules/user';
import { upload } from '@/libs/upload';
import type { QuotedPriceData } from '@/api/miscellaneous';
import { Toast, Dialog } from 'vant';
import DataDoesNotExist from '@/components/DataDoesNotExist.vue';
import { base64toFile, captureVideoCover } from '@/libs/utils';
import { uploadVideo } from '@/libs/uploadVideo';
import UpLoad from '@/components/Upload/Upload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuotedPrice',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();
const isShowCityPicker = ref(false);
const detail = ref<any>({});
const imgList = ref<any[]>([]);
const submitdata = ref<QuotedPriceData>({
    profile: '',
    price: '',
    photos: [],
    payTerm: '',
    areaId: '',
    address: '',
    categoryId: '',
    location: [],
    quantity: '0',
    video: [],
});
const addressName = ref('');
const isDataExist = ref(false);
const videoImg = ref<any>({});

const isShowList = ref(false);
const list = ref<any[]>([]);
const radio = ref<any>(false);

const isShowResult = ref(false);
const resultstatus = ref(false);
const result = ref('');



onBeforeMount(() => {
    const { type } = route.query;
    console.log(radio.value);
    if (type == 'engineer') {
        getEngineerData();
    } else {
        getData();
    }
});
const clickmethod = () => {
    if (radio.value == false) {
        submitdata.value.payTerm = '1';
    } else {
        submitdata.value.payTerm = '0';
    }
};

/**
 * 单品报价信息获取
 * */
const getData = () => {
    getQuotedPriceDetail({ id: route.query.id as string }).then(res => {
        if (res.online) {
            detail.value = res;
            let { address, areaId } = userStoreModule.userDetail;
            submitdata.value.payTerm = res.payTerm;
            submitdata.value.categoryId = res.categoryId;
            submitdata.value.location = userStoreModule.userDetail.location;
            addressName.value = res.userCertification.address;
            submitdata.value.areaId = res.userCertification.areaId;
            submitdata.value.address = res.userCertification.address;
            getList();
        } else {
            isDataExist.value = true;
        }
    });
};

/**
 * 工程报价信息获取
 * */
const getEngineerData = () => {
    const { id, orderId } = route.query;
    getEngineeringOffer({ id, orderId }).then((res: any) => {
        detail.value = res;
        let { shortAddress, areaId } = userStoreModule.userDetail;
        submitdata.value.payTerm = res.payTerm;
        submitdata.value.categoryId = res.categoryId;
        submitdata.value.location = userStoreModule.userDetail.location;
        addressName.value = res.userCertification.address || shortAddress;
        submitdata.value.areaId = res.userCertification.areaId || areaId;
        submitdata.value.address = res.userCertification.address || shortAddress;
    });
};

const confirm = (data: any[]) => {
    let set = new Set(data.map((el: { label: string }) => el.label)),
        address = Array.from(set).join('');
    addressName.value = address;
    submitdata.value.areaId = data[2].value;
    submitdata.value.address = address;
};

const afterRead = (data: any) => {
    console.log(data,'--------');
    if (!Array.isArray(data)) data = [data];
    let imgUploads = Promise.all(data.map((el: any) => upload({ type: 'quotation', obj: el })));
    let uploading = Toast.loading({
        message: '图片上传中...',
        duration: 0,
    });
    imgUploads.then(res => {
        let photos = res.map(el => el.url);
        imgList.value = [...imgList.value, ...res];
        // @ts-ignore
        submitdata.value.photos = [...submitdata.value.photos, ...photos];
        uploading.clear();
    });
};

const closeImg = (idx: number) => {
    imgList.value.splice(idx, 1);
    submitdata.value.photos.splice(idx, 1);
};

const submit = () => {
    console.log(submitdata.value, submitdata.value.photos);
    if (submitdata.value.photos.length == 0) {
        Toast.success("需要上传报价实拍图！！！");
        return;
    }

    if (submitdata.value.photos.length === 0 && submitdata.value.video.length != 0) {
        submitdata.value.photos = [videoImg.value.url];
    }
    quotedPrice(route.query.id as string, submitdata.value).then(_res => {
        //Toast.success('报价成功');
        console.log(_res, '--res');
        resultstatus.value = true;
        result.value = '您的报价已发布成功';
        isShowResult.value = true;

        Toast.success("报价成功");

        if (router.currentRoute.value.query.back) {
            const { id, projectId, detailType,purchaseid} = router.currentRoute.value.query;
            if (detailType == 'single' || detailType == 'project') {
                router.push({ name: 'BuyDetail', query: { id: id } });
            } else if (detailType == 'wanttoby') {
                router.push({ name: "WantToBuy", query: {} });
            }else if (detailType == "QuotedPriceList") {
                router.push({ name: "QuotedPriceList", query: { id: id, purchaseid: purchaseid } });
            }

        } else {
            setTimeout(() => {
                router.back();
            }, 2000);
        }

    });
};

const back = () => {
    router.back();
};

const videoAfterRead = (file: any) => {
    let uploading = Toast.loading({
        message: '视频上传中...',
        duration: 0,
        overlay: true,
    });
    captureVideoCover(file.file).then(videoImage => {
        const imgFile = base64toFile(videoImage as string, `${new Date().getTime()}Img`);
        const httpRequests = Promise.all([
            upload({ type: 'quotation', obj: { file: imgFile, content: videoImage } }),
            uploadVideo({ type: 'quotation', obj: file }),
        ]);
        httpRequests.then(res => {
            submitdata.value.video = [res[1].url];
            videoImg.value = res[0];
            // dataList.value[uploadIndex.value].video = res;
            uploading.clear();
        });
    });
};

const getList = () => {
    quotedPriceSupply({ id: detail.value.categoryId }).then((res: any) => {
        list.value = res.items;
        if (res.items.length > 1) {
            isShowList.value = true;
        } else {
            if (res.items.length == 1) {
                selectSupply(res.items[0]);
            }
        }
    });
};

const selectSupply = (data: any) => {
    const { address, areaId, photos, price, location } = data;
    submitdata.value.price = price;
    submitdata.value.photos = photos;
    submitdata.value.areaId = areaId;
    submitdata.value.address = address;
    submitdata.value.location = location;
    addressName.value = address;
    imgList.value = photos.map((el: string) => ({ img: el }));
    isShowList.value = false;
};



const __returned__ = { route, router, isShowCityPicker, detail, imgList, submitdata, addressName, isDataExist, videoImg, isShowList, list, radio, isShowResult, resultstatus, result, clickmethod, getData, getEngineerData, confirm, afterRead, closeImg, submit, back, videoAfterRead, getList, selectSupply, onBeforeMount, ref, getQuotedPriceDetail, getWechatSDKSign, quotedPrice, getLocation, quotedPriceSupply, getEngineeringOffer, getHasCard, useRoute, useRouter, CityPicker, userStoreModule, upload, Toast, Dialog, DataDoesNotExist, base64toFile, captureVideoCover, uploadVideo, UpLoad }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})